<template>
  <section>
    <section class="flex">
      <section class="width-690">
        <section class="abs-top-right">
          <div class="flex-sb-center">
            <div
              v-if="step==1"
              class="flex">
              <v-button
                red
                @click="handleCancel">{{isQuote?'Cancel':'Discard'}}</v-button>
              <v-button
                green
                @click="handlerNext">{{isEdit&&!isQuote?'Save':'Next'}}</v-button>
            </div>
            <div
              v-if="step==2"
              class="flex">
              <v-button
                gray
                @click="handleBack">Back</v-button>
              <v-button
                v-if="!isQuote"
                green
                @click="handleComplete(1)">Complete Buyable</v-button>
              <v-button
                v-else
                green
                @click="handleComplete(2)">Save</v-button>
            </div>
          </div>
        </section>
        <div class="form-container">
          <sme-kyc-form
            v-if="step==1"
            ref="sme-form"
            :form="formData"
            :is-quote="isQuote"
            :isEdit="isEdit"
            @getFormData="getSMEFormData"></sme-kyc-form>
          <reply-form
            v-if="step==2"
            ref="reply-form"
            :form="formData"
            @updateRefer="updateRefer"
            @getFormData="getFormData"></reply-form>
          <!--          <lazy-dom-->
          <!--            v-if="step==1"-->
          <!--            notLoading>-->
          <!--            <use-personal-data-->
          <!--              ref="use-personal-data"-->
          <!--              :marketing_data="formData.marketing_data"-->
          <!--              :company_name="formData.company_language"-->
          <!--              @sendData="getData"></use-personal-data>-->
          <!--          </lazy-dom>-->
        </div>
      </section>
      <template v-if="isEdit||isQuote">
        <section class="right mg-l-40">
          <ticket-remark
            :isQuote="isQuote"
            :quoId="form.quo_id"
            :remark="remark"
            :ticket-id="ticketId"></ticket-remark>
        </section>
      </template>
    </section>
    <div class="bottom-btn width-690 mg-t-30">
      <div class="flex-sb-center">
        <div
          v-if="step==1"
          class="flex flex-sb-center flex-1">
          <v-button
            red
            @click="handleCancel">{{isQuote?'Cancel':'Discard'}}</v-button>
          <v-button
            green
            @click="handlerNext">{{isEdit&&!isQuote?'Save':'Next'}}</v-button>
        </div>
        <div
          v-if="step==2"
          class="flex flex-sb-center flex-1">
          <v-button
            gray
            @click="handleBack">Back</v-button>
          <v-button
            v-if="!isQuote"
            green
            @click="handleComplete(1)">Complete Buyable</v-button>
          <v-button
            v-else
            green
            @click="handleComplete(2)">Save</v-button>
        </div>
      </div>
    </div>
    <send-contact-dialog
      v-model="showSMS"
      :form="formData"
      :isFormTicket="isQuote"
      @send="handlerSend"
      @skip="handlerSend"></send-contact-dialog>
  </section>
</template>
<script>
import UsePersonalData from '@/views/components/use-personal-data'
import smeKycForm from './sme-kyc-form'
import replyForm from './reply-form'
import sendContactDialog from './send-contact-dialog'
import TicketRemark from '@/views/tickets/components/ticket-remark'
import {editSMETicket,replySMEQuote} from '@api/new_sme'

export default {
  name:'EditSmeKyc',
  components:{
    // UsePersonalData,
    smeKycForm,
    replyForm,
    sendContactDialog,
    TicketRemark
  },
  props:{
    form: {
      type: Object,
      default: () => ({})
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    isQuote: {
      type: Boolean,
      default: false
    },
    remark: {
      type: Array,
      default: () => ([])
    },
  },
  data(){
    return{
      showSMS:false,
      formData:{
        marketing_data:{},
        company_language:''
      },
      personalData:{},
      step:1,
      formParams:{}
    }
  },
  computed:{
    isAttachCustomer(){
      let {customer_id}=this.formData||{}
      return customer_id>0
    },
    ticketId(){
      let {ticket_id} =this.$route.query||{}
      if(this.isQuote){
        return this.form.ticket_id
      }
      return ticket_id
    },
    orderId(){
      let {order_id} =this.form||{}
      return order_id||''
    }
  },
  watch: {
    form: {
      immediate:true,
      handler(val) {
        this.formData = {...this.formData,...val}
      }
    },
  },
  methods:{
    handleBack(){
      this.scrollTo(0)
      this.step=1
    },
    getData(personalData){
      this.personalData = personalData
    },
    async getSMEFormData(data){
      const params = {
        ...data,
        order_id: this.orderId
      }
      this.formData = {...this.formData,...data}
      if(!this.isAttachCustomer){
        delete  this.formData.addr_district
        delete  this.formData.addr_area
        delete  this.formData.addr_region
        delete  this.formData.addr_room
        delete  this.formData.addr_floor
        delete  this.formData.addr_block
        delete  this.formData.addr_building
      }
      if(!this.isEdit){
        await this.network().editSMETicket(this.formData)
        this.step=2
      }else {
        this.network().editSMETicket(this.formData)
      }
    },
    getFormData(data){
      const params = {
        ...data,
        order_id: this.orderId
      }
      this.formParams = JSON.parse(JSON.stringify(params))
    },
    //reply quote or edit quote 1:reply quote 2.edit quote
    async handleComplete(type){
      let data =  await this.$refs['reply-form'].submitForm()
      this.formData = {...this.formData,data}
      let params = {
        ...data
      }
      let {excess} = params||{}
      if(excess.length<=0)
        params.excess =null
      await this.network().replySMEQuote(params)
      // this.showSMS =true
      // if(type==1)
      // {
      //
      // }
      // else {
      //
      // }
    },
    async handlerNext(){
      // this.$refs['use-personal-data'].handleSendData()
      await this.$refs['sme-form'].submitForm()
    },
    handleCancel(){
      this.$emit('refresh')
    },
    updateRefer(data){
      this.formData.referrer = data
    },
    handlerSend(){
      this.$router.push({
        path: '/quoting/send/payment',
        query: {
          order_id: this.orderId,
          product_id: 80,
          sme_versions: 3,
        }
      })
      // this.$emit('refresh')
    },
    network(){
      return{
        editSMETicket: async (params) => {
          const {data} = await editSMETicket({
            ...params,
            ticket_id:this.ticketId
          })
          this.scrollTo(0)
          if(this.isEdit)
            this.$emit('refresh')
        },
        replySMEQuote: async (params) => {
          const {data} = await replySMEQuote({
            ...params,
            order_id:this.orderId
          })
          this.handlerSend()
        },
      }
    }
  }
}
</script>
<style lang="scss" scoped>
.width-690{
  width: 690px;
  max-width: 690px;
  position: relative;
}
.just-end{
  justify-content: end;
}
.mg-l-40{
  margin-left: 40px;
}
.mg-t-30{
  //margin-top: 30px;
}
</style>
